/* eslint-disable */
import store from "../../store";
import Errors from "../../Errors";
import CartHelpersMixin from "../../mixins/CartHelpersMixin";
import ProductHelpersMixin from "../../mixins/ProductHelpersMixin";

export default {
    mixins: [CartHelpersMixin, ProductHelpersMixin],

    props: [
        "customerEmail",
        "customerPhone",
        "gateways",
        "defaultAddress",
        "addresses",
        "countries",
    ],

    data() {
        return {
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                shipping: {},
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                ship_to_a_different_address: false,
            },
            states: {
                billing: {},
                shipping: {},
            },
            placingOrder: false,
            pendingPlaceOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
            authorizeNetToken: null,
            supportsApplePay: false,
            supportsGooglePay: false,
        };
    },

    computed: {
        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        hasBillingStates() {
            return Object.keys(this.states.billing).length !== 0;
        },

        hasShippingStates() {
            return Object.keys(this.states.shipping).length !== 0;
        },

        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },

        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },

        shouldShowPaymentInstructions() {
            return ["bank_transfer", "check_payment"].includes(
                this.form.payment_method
            );
        },

        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
        },
    },

    watch: {
        "form.billingAddressId": function () {
            this.mergeSavedBillingAddress();
        },

        "form.shippingAddressId": function () {
            this.mergeSavedShippingAddress();
        },

        "form.billing.city": function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        "form.shipping.city": function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        "form.billing.zip": function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        "form.shipping.zip": function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        "form.billing.state": function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        "form.shipping.state": function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        "form.ship_to_a_different_address": function (newValue) {
            if (newValue && this.form.shippingAddressId) {
                this.form.shipping =
                    this.addresses[this.form.shippingAddressId];
            } else {
                $('#shipping-country').val("");
                this.form.shipping = {};
                this.resetAddressErrors("shipping");
            }

            if (
                newValue &&
                !this.form.shipping.country &&
                this.form.billing.country
            ) {
                this.changeShippingCountry(this.form.billing.country);
            }

            this.addTaxes();
        },

        "form.terms_and_conditions": function () {
            this.errors.clear("terms_and_conditions");
        },

        "form.payment_method": function (newPaymentMethod) {
            if (newPaymentMethod === "paypal") {
                this.$nextTick(this.renderPayPalButton);
            }

            if (newPaymentMethod !== "stripe") {
                this.stripeError = "";
            }
        },

        loadingOrderSummary: function (isLoading) {
            if (!isLoading) {
                this.flushPendingPlaceOrder();
            }
        },
    },

    created() {
        if (this.defaultAddress.address_id) {
            this.form.billingAddressId = this.defaultAddress.address_id;
            this.form.shippingAddressId = this.defaultAddress.address_id;
        }

        if (!this.hasAddress) {
            this.form.newBillingAddress = true;
            this.form.newShippingAddress = true;
        }

        if (!this.form.billing.country && this.firstCountry) {
            this.changeBillingCountry(this.firstCountry);
        }

        this.$nextTick(() => {
            this.changePaymentMethod(this.firstPaymentMethod);

            if (store.state.cart.shippingMethodName) {
                this.changeShippingMethod(store.state.cart.shippingMethodName);
            } else {
                this.updateShippingMethod(this.firstShippingMethod);
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(Shop.stripePublishableKey);

                this.renderStripeElements();
            }
        });
    },

    mounted() {
        requestAnimationFrame(() => {
          this.setPayFlags();
        });
    },

    methods: {
        csrfToken() {
            if (typeof window.resolveCsrfToken === "function") {
                return window.resolveCsrfToken();
            }

            const metaToken = document
                .querySelector('meta[name="csrf-token"]')
                ?.getAttribute("content");

            return metaToken || Shop.csrfToken || "";
        },

        getAjaxErrorMessage(xhr, fallbackMessage) {
            const responseText = xhr?.responseText;

            if (
                typeof responseText === "string" &&
                responseText.trim() !== "" &&
                !responseText.includes("<html")
            ) {
                return (
                    xhr?.responseJSON?.message ||
                    xhr?.responseJSON?.error ||
                    responseText ||
                    fallbackMessage
                );
            }

            return (
                xhr?.responseJSON?.message ||
                xhr?.responseJSON?.error ||
                fallbackMessage
            );
        },

        syncFormFromDom() {
            const checkoutForm = document.getElementById("checkoutForm");

            if (!checkoutForm) {
                return;
            }

            const readValue = (name) =>
                checkoutForm.querySelector(`[name="${name}"]`)?.value ?? "";

            const readCheckedValue = (name) =>
                checkoutForm.querySelector(`[name="${name}"]:checked`)?.value ??
                "";

            this.$set(this.form, "customer_email", readValue("customer_email"));
            this.$set(this.form, "customer_phone", readValue("customer_phone"));
            this.$set(
                this.form,
                "payment_method",
                readCheckedValue("payment_method") || this.form.payment_method
            );
            this.$set(
                this.form,
                "terms_and_conditions",
                !!checkoutForm.querySelector(
                    '#terms-and-conditions:checked'
                )
            );
            this.$set(
                this.form,
                "ship_to_a_different_address",
                !!checkoutForm.querySelector(
                    '#ship-to-different-address:checked'
                )
            );

            if (!this.hasAddress || this.form.newBillingAddress) {
                this.$set(this.form, "billing", {
                    ...this.form.billing,
                    first_name: readValue("billing[first_name]"),
                    last_name: readValue("billing[last_name]"),
                    address_1: readValue("billing[address_1]"),
                    address_2: readValue("billing[address_2]"),
                    zip: readValue("billing[zip]"),
                    city: readValue("billing[city]"),
                    country: readValue("billing[country]"),
                    state: readValue("billing[state]"),
                });
            }

            if (
                this.form.ship_to_a_different_address &&
                (!this.hasAddress || this.form.newShippingAddress)
            ) {
                this.$set(this.form, "shipping", {
                    ...this.form.shipping,
                    first_name: readValue("shipping[first_name]"),
                    last_name: readValue("shipping[last_name]"),
                    phone: readValue("shipping[phone]"),
                    address_1: readValue("shipping[address_1]"),
                    address_2: readValue("shipping[address_2]"),
                    zip: readValue("shipping[zip]"),
                    city: readValue("shipping[city]"),
                    country: readValue("shipping[country]"),
                    state: readValue("shipping[state]"),
                });
            }
        },

        getFirstValidationMessage(errors) {
            if (!errors || typeof errors !== "object") {
                return null;
            }

            const firstErrorKey = Object.keys(errors)[0];

            if (!firstErrorKey) {
                return null;
            }

            const firstError = errors[firstErrorKey];

            if (Array.isArray(firstError)) {
                return firstError[0] || null;
            }

            return firstError || null;
        },

        flushPendingPlaceOrder() {
            if (
                !this.pendingPlaceOrder ||
                this.loadingOrderSummary ||
                this.placingOrder
            ) {
                return;
            }

            this.pendingPlaceOrder = false;
            this.submitOrder();
        },

        notifyAjaxError(xhr, fallbackMessage) {
            if (xhr?.status === 419) {
                this.$notify(
                    "Sesja checkout wygasla. Odswiez strone i sprobuj ponownie.",
                    { type: "warning", duration: 5000 }
                );

                return;
            }

            const message = this.getAjaxErrorMessage(xhr, fallbackMessage);

            this.$notify(message, { type: "warning" });
        },

        syncCartAfterOrderPlacement(cart) {
            if (cart && typeof cart === "object") {
                Shop.cart = cart;
                store.updateCart(cart);

                return;
            }

            store.clearCart();
            Shop.cart = { ...store.state.cart };
        },

        async syncCartAfterSummaryResponse(cart) {
            const hasItemsBeforeUpdate = this.cartIsNotEmpty;
            const responseItems = cart?.items || {};
            const responseCartIsEmpty = $.isEmptyObject(responseItems);

            if (!hasItemsBeforeUpdate || !responseCartIsEmpty) {
                return cart;
            }

            if (typeof window.refreshCart !== "function") {
                return null;
            }

            const refreshedCart = await window.refreshCart();

            if ($.isEmptyObject(refreshedCart?.items || {})) {
                return null;
            }

            return refreshedCart;
        },

      async setPayFlags() {
  // --- APPLE PAY ---
  try {
    const APS = window.ApplePaySession;
    this.supportsApplePay =
      !!APS &&
      typeof APS.canMakePayments === 'function' &&
      !!APS.canMakePayments();

    // (opcjonalnie – jeśli chcesz wymagać aktywnej karty)
    // if (this.supportsApplePay && typeof APS.canMakePaymentsWithActiveCard === 'function' && window.Shop?.appleMerchantId) {
    //   try {
    //     const hasActive = await APS.canMakePaymentsWithActiveCard(Shop.appleMerchantId);
    //     // WYMAGAJ aktywnej karty:
    //     // this.supportsApplePay = !!hasActive;
    //   } catch {}
    // }
  } catch { this.supportsApplePay = false; }

  // --- GOOGLE PAY (lokalnie przez Payment Request API, bez sieci) ---
  try {
    // Brak obsługi API
    if (!('PaymentRequest' in window)) {
      this.supportsGooglePay = false;
      return;
    }

    // Minimalna konfiguracja metody płatności
    const methodData = [{
      supportedMethods: 'https://google.com/pay',
      data: {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
            allowedCardNetworks: ['VISA', 'MASTERCARD'],
          },
        }],
      },
    }];

    const details = {
      total: { label: 'Test', amount: { currency: 'PLN', value: '1.00' } },
    };

    let req;
    try {
      req = new PaymentRequest(methodData, details);
    } catch {
      this.supportsGooglePay = false;
      return;
    }

    // 1️⃣ luźny sygnał – przeglądarka *może* obsługiwać GPay
    let can = false;
    if (typeof req.canMakePayment === 'function') {
      try { can = !!(await req.canMakePayment()); } catch {}
    }

    // 2️⃣ twardy sygnał – użytkownik ma zapisany instrument
    let enrolled = null;
    if (typeof req.hasEnrolledInstrument === 'function') {
      try { enrolled = !!(await req.hasEnrolledInstrument()); } catch { enrolled = null; }
    }

    // 3️⃣ heurystyka – Android + Chrome (bez Edge/Opera)
    const ua = navigator.userAgent || '';
    const isAndroid = /Android/i.test(ua);
    const isChrome = /Chrome\/\d+/i.test(ua) && !/Edg|OPR/i.test(ua);

    // 4️⃣ ostateczna decyzja
    this.supportsGooglePay =
      (enrolled === true) ||                      // potwierdzony instrument
      (enrolled === null && can && isAndroid && isChrome); // fallback heurystyka
  } catch {
    this.supportsGooglePay = false;
  }
},

        addNewBillingAddress() {
            this.resetAddressErrors("billing");

            this.form.billing = {};
            this.form.newBillingAddress = !this.form.newBillingAddress;

            if (!this.form.newBillingAddress) {
                this.mergeSavedBillingAddress();
            }
        },

        optionValues(option) {
            let values = [];

            for (let value of option.values) {
                values.push(value.label);
            }

            return values.join(', ');
        },

        addNewShippingAddress() {
            this.resetAddressErrors("shipping");

            this.form.shipping = {};
            this.form.newShippingAddress = !this.form.newShippingAddress;

            if (!this.form.newShippingAddress) {
                this.mergeSavedShippingAddress();
            }
        },

        // reset address errors based on address type
        resetAddressErrors(addressType) {
            Object.keys(this.errors.errors).map((key) => {
                key.indexOf(addressType) !== -1 && this.errors.clear(key);
            });
        },

        mergeSavedBillingAddress() {
            this.resetAddressErrors("billing");

            if (!this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.addresses[this.form.billingAddressId];
            }
        },

        mergeSavedShippingAddress() {
            this.resetAddressErrors("shipping");

            if (
                this.form.ship_to_a_different_address &&
                !this.form.newShippingAddress &&
                this.form.shippingAddressId
            ) {
                this.form.shipping =
                    this.addresses[this.form.shippingAddressId];
            }
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, "city", city);
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, "city", city);
        },

        changeBillingZip(zip) {
            this.$set(this.form.billing, "zip", zip);
        },

        changeShippingZip(zip) {
            this.$set(this.form.shipping, "zip", zip);
        },

        changeBillingCountry(country) {
            this.$set(this.form.billing, "country", country);

            if (country === "") {
                this.form.billing.state = "";
                this.states.billing = {};

                return;
            }
this.addTaxes();
            // this.fetchStates(country, (states) => {
            //     this.$set(this.states, "billing", states);
            //     this.$set(this.form.billing, "state", "");
            // });
        },

        changeShippingCountry(country) {
            this.$set(this.form.shipping, "country", country);

            if (country === "") {
                this.form.shipping.state = "";
                this.states.shipping = {};

                return;
            }

            this.addTaxes();

            //
            // this.fetchStates(country, (states) => {
            //     this.$set(this.states, "shipping", states);
            //     this.$set(this.form.shipping, "state", "");
            // });
        },

        // fetchStates(country, callback) {
        //     $.ajax({
        //         method: "GET",
        //         url: route("countries.states.index", { code: country }),
        //     }).then(callback);
        // },

        changeBillingState(state) {
            this.$set(this.form.billing, "state", state);
        },

        changeShippingState(state) {
            this.$set(this.form.shipping, "state", state);
        },

        changePaymentMethod(paymentMethod) {
            this.$set(this.form, "payment_method", paymentMethod);
        },

        changeShippingMethod(shippingMethodName) {
            this.$set(this.form, "shipping_method", shippingMethodName);
        },

        addTaxes() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: "POST",
                url: route("cart.taxes.store"),
                headers: {
                    "X-CSRF-TOKEN": this.csrfToken(),
                },
                data: {
                    ...this.form,
                    locale: this.currentLocale(),
                    _token: this.csrfToken(),
                    ship_to_a_different_address:
                        +this.form.ship_to_a_different_address,
                },
            })
                .then(async (cart) => {
                    const syncedCart = await this.syncCartAfterSummaryResponse(
                        cart
                    );

                    if (!syncedCart) {
                        this.$notify(
                            "Nie udalo sie zsynchronizowac koszyka po zmianie kodu pocztowego.",
                            { type: "warning", duration: 5000 }
                        );

                        return;
                    }

                    cart = syncedCart;
                    store.updateCart(cart);

                    if (cart.shippingMethodName) {
                        this.changeShippingMethod(cart.shippingMethodName);
                    }
                })
                .catch((xhr) => {
                    this.notifyAjaxError(
                        xhr,
                        "Nie udalo sie przeliczyc podsumowania zamowienia."
                    );
                })
                .always(() => {
                    this.loadingOrderSummary = false;
                });
        },

        placeOrder() {
            this.syncFormFromDom();

            if (!this.form.terms_and_conditions || this.placingOrder) {
                return;
            }

            if (this.loadingOrderSummary) {
                this.pendingPlaceOrder = true;

                return;
            }

            this.pendingPlaceOrder = false;
            this.submitOrder();
        },

        submitOrder() {
            this.placingOrder = true;

            $.ajax({
                method: "POST",
                url: route("checkout.create"),
                headers: {
                    "X-CSRF-TOKEN": this.csrfToken(),
                },
                data: {
                    ...this.form,
                    locale: this.currentLocale(),
                    _token: this.csrfToken(),
                    ship_to_a_different_address:
                        +this.form.ship_to_a_different_address,
                },
            })
                .then((response) => {
                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    } else if (this.form.payment_method === "stripe") {
                        this.confirmStripePayment(response);
                    } else if (this.form.payment_method === "paytm") {
                        this.confirmPaytmPayment(response);
                    } else if (this.form.payment_method === "razorpay") {
                        this.confirmRazorpayPayment(response);
                    } else if (this.form.payment_method === "paystack") {
                        this.confirmPaystackPayment(response);
                    } else if (this.form.payment_method === "authorizenet") {
                        this.confirmAuthorizeNetPayment(response);
                    } else if (this.form.payment_method === "flutterwave") {
                        this.confirmFlutterWavePayment(response);
                    } else if (this.form.payment_method === "mercadopago") {
                        this.confirmMercadoPagoPayment(response);
                    } else {
                        this.confirmOrder(
                            response.orderId,
                            this.form.payment_method
                        );
                    }
                })
                .catch((xhr) => {
                    this.placingOrder = false;
                    $('html, body').animate({
                        scrollTop: $("#checkoutForm").offset().top - 130
                    }, 700);
                    if (xhr.status === 422) {
                        this.errors.record(xhr.responseJSON.errors);

                        const validationMessage = this.getFirstValidationMessage(
                            xhr?.responseJSON?.errors
                        );

                        if (validationMessage) {
                            this.$notify(validationMessage, {
                                type: "warning",
                            });
                        }
                    }

                    this.notifyAjaxError(
                        xhr,
                        "Nie udalo sie zapisac zamowienia."
                    );


                });
        },

        confirmOrder(orderId, paymentMethod, params = {}) {
            $.ajax({
                method: "GET",
                url: route("checkout.complete.store", {
                    orderId,
                    paymentMethod,
                    ...params,
                }),
            })
                .then((response) => {
                    this.syncCartAfterOrderPlacement(response?.cart);

                    window.location.href =
                        response?.redirectUrl || route("checkout.complete.show");
                })
                .catch((xhr) => {
                    this.placingOrder = false;
                    this.loadingOrderSummary = false;

                    this.deleteOrder(orderId);
                    this.notifyAjaxError(
                        xhr,
                        "Nie udalo sie potwierdzic zamowienia."
                    );
                });
        },

        deleteOrder(orderId) {
            if (!orderId) {
                return;
            }

            $.ajax({
                method: "GET",
                url: route("checkout.payment_canceled.store", { orderId }),
            }).then((xhr) => {
                this.$notify(xhr.message);
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal
                .Buttons({
                    async createOrder() {
                        try {
                            response = await $.ajax({
                                method: "POST",
                                url: route("checkout.create"),
                                headers: {
                                    "X-CSRF-TOKEN": vm.csrfToken(),
                                },
                                data: {
                                    ...vm.form,
                                    locale: vm.currentLocale(),
                                    _token: vm.csrfToken(),
                                    ship_to_a_different_address:
                                        +vm.form.ship_to_a_different_address,
                                },
                            });

                            return response.resourceId;
                        } catch (xhr) {
                            if (xhr.status === 422) {
                                vm.errors.record(xhr.responseJSON.errors);
                            } else {
                                vm.notifyAjaxError(
                                    xhr,
                                    "Nie udalo sie zapisac zamowienia."
                                );
                            }
                        }
                    },
                    onApprove() {
                        vm.loadingOrderSummary = true;

                        vm.confirmOrder(response.orderId, "paypal", response);
                    },
                    onError() {
                        vm.deleteOrder(response.orderId);
                    },
                    onCancel() {
                        vm.deleteOrder(response.orderId);
                    },
                })
                .render("#paypal-button-container");
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create("card", {
                hidePostalCode: true,
            });

            this.stripeCardElement.mount("#stripe-card-element");
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                            state: this.form.billing.state,
                        },
                    },
                },
            });

            if (result.error) {
                this.placingOrder = false;
                this.stripeError = result.error.message;

                this.deleteOrder(orderId);
            } else {
                this.confirmOrder(orderId, "stripe", result);
            }
        },

        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: "",
                flow: "DEFAULT",
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: "TXN_TOKEN",
                    amount: amount,
                },
                merchant: {
                    name: Shop.storeName,
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        if (response.STATUS === "TXN_SUCCESS") {
                            this.confirmOrder(orderId, "paytm", response);
                        } else if (response.STATUS === "TXN_FAILURE") {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }

                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        if (eventName === "APP_CLOSED") {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config)
                .then(() => {
                    window.Paytm.CheckoutJS.invoke();
                })
                .catch(() => {
                    this.deleteOrder(orderId);
                });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;

            let vm = this;

            new window.Razorpay({
                key: Shop.razorpayKeyId,
                name: Shop.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: Shop.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    vm.placingOrder = true;

                    vm.confirmOrder(
                        razorpayOrder.receipt,
                        "razorpay",
                        response
                    );
                },
                modal: {
                    ondismiss() {
                        vm.deleteOrder(razorpayOrder.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },

        confirmPaystackPayment({
            key,
            email,
            amount,
            ref,
            currency,
            order_id,
        }) {
            let vm = this;

            PaystackPop.setup({
                key,
                email,
                amount,
                ref,
                currency,
                onClose() {
                    vm.placingOrder = false;

                    vm.deleteOrder(order_id);
                },
                callback(response) {
                    vm.placingOrder = false;

                    vm.confirmOrder(order_id, "paystack", response);
                },
                onBankTransferConfirmationPending(response) {
                    vm.placingOrder = false;

                    vm.confirmOrder(order_id, "paystack", response);
                },
            }).openIframe();
        },

        confirmAuthorizeNetPayment(authorizeNetOrder) {
            this.authorizeNetToken = authorizeNetOrder.token;

            this.$nextTick(() => {
                this.$refs.authorizeNetForm.submit();

                this.authorizeNetToken = null;
            });
        },

        confirmFlutterWavePayment({
            public_key,
            tx_ref,
            order_id,
            amount,
            currency,
            payment_options,
            redirect_url,
        }) {
            let vm = this;

            FlutterwaveCheckout({
                public_key,
                tx_ref,
                amount,
                currency,
                payment_options: payment_options.join(", "),
                redirect_url,
                customer: {
                    email: this.form.customer_email,
                    phone_number: this.form.customer_phone,
                    name: this.form.billing.full_name,
                },
                customizations: {
                    title: Shop.storeName,
                    logo: Shop.storeLogo,
                },
                onclose(incomplete) {
                    vm.placingOrder = false;

                    if (incomplete) {
                        vm.deleteOrder(order_id);
                    }
                },
            });
        },

        confirmMercadoPagoPayment(mercadoPagoOrder) {
            this.placingOrder = false;

            const supportedLocales = {
                en_US: "en-US",
                es_AR: "es-AR",
                es_CL: "es-CL",
                es_CO: "es-CO",
                es_MX: "es-MX",
                es_VE: "es-VE",
                es_UY: "es-UY",
                es_PE: "es-PE",
                pt_BR: "pt-BR",
            };

            const mercadoPago = new MercadoPago(mercadoPagoOrder.publicKey, {
                locale:
                    supportedLocales[mercadoPagoOrder.currentLocale] || "en-US",
            });

            mercadoPago.checkout({
                preference: {
                    id: mercadoPagoOrder.preferenceId,
                },
                autoOpen: true,
            });
        },
    },
};
